import { render, staticRenderFns } from "./Manifest.vue?vue&type=template&id=0d8a31b4&scoped=true&"
import script from "./Manifest.vue?vue&type=script&lang=js&"
export * from "./Manifest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a31b4",
  null
  
)

export default component.exports